import axios from 'axios';
import type { APIResponse } from '~/api/utils';

const API_URL = '/async';

class AsyncService {
    async getTask(id: string): Promise<APIResponse<any>> {
        const response = await axios.get(`${API_URL}/${id}`);
        return response.data;
    }
}

export default new AsyncService();
